import React, { useRef } from "react";
import { RiPlayMiniFill } from "react-icons/ri";
import { Link } from "react-router-dom";

export default function Lib_Card({ data, type }) {
  const playPause = useRef();

  const { singerThumb, thumbnail, _id, movie, title, singer } = data;

  const showPlayPause = () => {
    playPause.current.style.opacity = 1;
    playPause.current.style.transform = "translateY(-36px)";
  };
  const unShowPlayPause = () => {
    playPause.current.style.opacity = 0;
    playPause.current.style.transform = "translateY(0px)";
  };

  return (
    <div
      onMouseOver={showPlayPause}
      onMouseOut={unShowPlayPause}
      className="ml-5 mr-5 mt-10 bg-[#2a2a2a] p-4 pb-6 rounded-lg cursor-pointer hover:bg-[#303030] transition-all ease-in-out relative"
    >
      <div
        style={{
          backgroundImage: `url(${type == "song" ? thumbnail : singerThumb})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          borderRadius: "50%",
          width: 180,
          height: 180,
          marginBottom: 20,
        }}
      ></div>
      <div className="">
        <h2
          style={{
            fontSize: 18,
            color: "white",
            marginBottom: 4,
          }}
        >
          {type == "artist"
            ? singer && singer.substring(0, 22)
            : title && title.substring(0, 18)}
        </h2>
        <p
          style={{
            fontSize: 16,
            opacity: 0.6,
            color: "white",
          }}
        >
          {type}
        </p>
      </div>
      <div
        ref={playPause}
        style={{ boxSizing: "border-box", padding: 8 }}
        className="rounded-full  bg-[#1fdf64]  opacity-0 absolute right-4 bottom-20  transition-all ease-in-out flex items-center justify-center duration-300"
      >
        <RiPlayMiniFill
          style={{
            fontSize: 30,
          }}
          className="text-black rounded-full "
        />
      </div>
    </div>
  );
}
